export const header = {
  marginTop: 10,
}
